import Handlebars from 'handlebars';

Handlebars.registerHelper('grouped_each', function (every, context, options) {
  var out = '';
  var subcontext = [];
  var i;
  if (context && context.length > 0) {
    for (i = 0; i < context.length; i++) {
      if (i > 0 && i % every === 0) {
        out += options.fn(subcontext);
        subcontext = [];
      }
      subcontext.push(context[i]);
    }
    out += options.fn(subcontext);
  }
  return out;
});
